import { Component, OnInit, Input } from '@angular/core';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { Router, ActivatedRoute } from '@angular/router';
import { RolesService } from 'app/components/roles/roles.service';
import { CONSTANTS, Tabs, Views } from 'environments/common';

@Component({
  selector: 'app-menu-exhibitor',
  templateUrl: './menu-exhibitor.component.html',
  styleUrls: ['./menu-exhibitor.component.css']
})
export class MenuExhibitorComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  @Input() active: string = '';

  roles: object = CONSTANTS.ROLES;

  constructor(private catalogueService: CatalogueService, private router: Router, public rolesService: RolesService) { }

  goTo(page) {

    if (!page) {
      return;
    }

    let url = '';
    let queryParams = {};

    switch(page) {
      case 'exhibitors':
        url = this.catalogueService.getProperty('eventName') + '/exhibitor-backoffice/exhibitors';
        break;
      default:
        url = this.catalogueService.getProperty('eventName') + '/exhibitor-backoffice/util-info';
        break;
    }

    this.router.navigate([url], { queryParams: queryParams });

  }

  isActive(tab) {
    return this.active === tab ? true : false;
  }

  ngOnInit() {
  }

}
